<template>
  <section class="alternate-section">
    <div class="container">
      <div
          class="alternate-item"
          v-for="(item, index) in CoreFeaturesList"
          :key="index"
          :class="{ reverse: index % 2 !== 0 }"
      >
        <div class="img-box">
           <img :src="item.image"/>
        </div>
        <div class="text-box">
          <h3 class="title">{{ getItemTitle(item) }}</h3>
          <p class="desc">{{ getItemDesc(item) }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AlternateSection',
  props: {
    CoreFeaturesList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getItemTitle(item) {
      return item.titleKey ? this.$t(item.titleKey) : item.title
    },
    getItemDesc(item) {
      return item.descKey ? this.$t(item.descKey) : item.desc
    }
  }
}
</script>

<style scoped>
.alternate-section {
  width: calc(100% - 40px);
  background-color: #000;
  padding: 80px 20px;
}

.container {
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 60px;
}

.alternate-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
}

.img-box {
  width: 50%;
  aspect-ratio: 16 / 10;
  background: #fff;
  border-radius: 12px;
  overflow: hidden;
  >img{
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
}

.text-box {
  width: 50%;
  color: #fff;
}

.title {
  margin: 0 0 16px;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
}

.desc {
  margin: 0;
  font-size: 14px;
  color: #aaa;
  text-align: center;
  line-height: 1.6;
}

.alternate-item.reverse {
  flex-direction: row-reverse;
}

@media (max-width: 768px) {
  .alternate-item,
  .alternate-item.reverse {
    flex-direction: column;
    gap: 24px;
  }
  .img-box,
  .text-box {
    width: 100%;
  }
}
</style>